import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import { router } from './router/router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import './assets/font/iconfont.css'

var app = createApp(App)
app.use(router)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(ElementPlus, { size: 'small', zIndex: 3000 })
app.mount('#app')